import {CardInfoContent} from '../../../../components/CardInfoGuide/CardInfoGuide'

const accumulationRateInfo: CardInfoContent = {
  title: 'Pontos Base',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Ativar pontos base',
      description:
        'Liga ou desliga os pontos padrão do hotel. Se desativado, o hóspede só ganha pontos via regras específicas cadastradas.',
    },
    {
      label: 'Pontos base',
      description:
        'Quantidade de pontos aplicada quando não existe uma regra própria para o item. Use 0 para não conceder pontos base.',
    },
  ],
}

const accumulationSourcesInfo: CardInfoContent = {
  title: 'Origens de Acúmulo',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Serviços e experiências',
      description:
        'Define em quais origens o hóspede pode acumular pontos: serviços, classificação, serviços essenciais, experiência, atividade, tour, pesquisa e opinião.',
    },
  ],
}

const accumulationExpirationInfo: CardInfoContent = {
  title: 'Validade do Crédito',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Dias para expiração',
      description:
        'Quantidade de dias até o saldo de pontos expirar após ser creditado. 0 = sem expiração.',
    },
  ],
}

const earningLimitsInfo: CardInfoContent = {
  title: 'Limites de Acúmulo',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Teto por ação',
      description:
        'Limita o máximo de pontos que o hóspede pode ganhar em uma única ação. 0 = ilimitado.',
    },
    {
      label: 'Teto por estadia',
      description:
        'Limita o máximo de pontos que o hóspede pode ganhar durante uma mesma estadia. 0 = ilimitado.',
    },
  ],
}

const marginProtectionInfo: CardInfoContent = {
  title: 'Proteção',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Apenas itens com regras cadastradas',
      description:
        'Se ativado como "Sim", os pontos só serão gerados para itens com regras específicas. Se "Não", o hotel poderá usar os pontos base quando configurados.',
    },
  ],
}

const completedStatusInfo: CardInfoContent = {
  title: 'Status para Liberação',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Exigir status concluído',
      description:
        'Se ativado, os pontos só são creditados quando a origem estiver com um status liberado (ex.: completed).',
    },
    {
      label: 'Status que liberam os pontos',
      description:
        'Marque os status ativos do hotel em que os pontos passam a valer para resgate. O padrão é o status de concluído.',
    },
  ],
}

const redemptionMinimumsInfo: CardInfoContent = {
  title: 'Mínimos de Resgate',
  subtitle: 'Regras de Resgate',
  items: [
    {
      label: 'Pontos mínimos para resgate',
      description: 'Saldo mínimo que o hóspede precisa ter para resgatar uma recompensa.',
    },
  ],
}

const redemptionRulesInfo: CardInfoContent = {
  title: 'Regras de Resgate',
  subtitle: 'Regras de Resgate',
  items: [
    {
      label: 'Cliente logado',
      description: 'Exige que o hóspede esteja autenticado para acumular ou resgatar pontos.',
    },
    {
      label: 'Reserva ativa',
      description: 'Exige uma reserva ativa para o hóspede resgatar recompensas.',
    },
    {
      label: 'Resgate após checkout',
      description: 'Permite que o hóspede continue resgatando após o checkout da estadia.',
    },
    {
      label: 'Aprovação da equipe',
      description:
        'Se ativado, o resgate fica pendente até a equipe confirmar ou entregar a recompensa.',
    },
  ],
}

const antifraudCooldownInfo: CardInfoContent = {
  title: 'Carência',
  subtitle: 'Blindagem e Antifraude',
  items: [
    {
      label: 'Dias de carência',
      description:
        'Número de dias em que os pontos ficam pendentes antes de ficarem disponíveis. Evita o uso imediato seguido de cancelamento da origem.',
    },
  ],
}

const walletCapInfo: CardInfoContent = {
  title: 'Limite da Carteira',
  subtitle: 'Blindagem e Antifraude',
  items: [
    {
      label: 'Saldo máximo permitido',
      description:
        'O máximo de pontos que o hóspede pode acumular na carteira. Se atingir esse teto, ele precisa resgatar antes de acumular mais. 0 = ilimitado.',
    },
  ],
}

export {
  accumulationRateInfo,
  accumulationSourcesInfo,
  accumulationExpirationInfo,
  earningLimitsInfo,
  marginProtectionInfo,
  completedStatusInfo,
  redemptionMinimumsInfo,
  redemptionRulesInfo,
  antifraudCooldownInfo,
  walletCapInfo,
}
